import type { ReactNode } from 'react';
import type { MessageInstance } from 'antd/es/message/interface';

const SUCCESS_DURATION = 4;
const ERROR_DURATION = 6;

export type ToastContent = string | { content: ReactNode; duration?: number };

let messageApi: MessageInstance | null = null;

/** Wires the context-aware message instance from <App> into the toast helper. */
export function setToastMessage(instance: MessageInstance): void {
  messageApi = instance;
}

function emit(type: 'success' | 'error' | 'info' | 'warning', content: ToastContent): void {
  if (!messageApi) return;
  if (typeof content === 'string') {
    void messageApi[type]({
      content,
      duration: type === 'error' ? ERROR_DURATION : SUCCESS_DURATION,
    });
  } else {
    void messageApi[type](content);
  }
}

/** Dismissable top toasts (use instead of inline Alert banners on list pages). */
export const toast = {
  success(content: ToastContent): void {
    emit('success', content);
  },
  error(content: ToastContent): void {
    emit('error', content);
  },
  info(content: ToastContent): void {
    emit('info', content);
  },
  warning(content: ToastContent): void {
    emit('warning', content);
  },
};